import OapLoader from './code/Scripts/components/OapLoader.vue';

export default {
  components: {
    OapLoader,
  },
};
